import { render, staticRenderFns } from "./index.vue?vue&type=template&id=79aae619&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/activity/vip/index.scss?vue&type=style&index=0&id=79aae619&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79aae619",
  null
  
)

export default component.exports